// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1HPdt","title":"styles_title__Uvh7Z","items":"styles_items__Em6Vz","featureItem":"styles_featureItem__XDl3i"};
module.exports.__checksum = "ed3c1219237b"